<template>
  <f7-page>
    <div class="mx-auto w-11/12 sm:w-9/12 sm:min-w-150 mt-2 mb-10 sm:mt-12 max-w-4xl">
      <div
        class="sm:flex max-w-2xl"
      >
        <div
          class="text-4xl font-bold mr-10"
        >
          Personaliza la encuesta
        </div>
        <img
          class="sm:w-2/6 w-64"
          src="@/assets/questions.svg"
        >
      </div>
      <div class="font-bold text-lg mb-4">
        Configuración
      </div>
      <div
        class="p-4 shadow cursor-pointer"
        @click="accordion.parameters = !accordion.parameters"
      >
        <div class="flex justify-between">
          <div class="font-bold">
            Parámetros
          </div>
          <eva-icon
            :name="accordion.parameters ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'"
            fill="#282A43"
          />
        </div>
      </div>
      <div
        v-if="accordion.parameters"
        class="content shadow p-4 bg-white"
      >
        <!-- <label
          class="custom-label max-w-lg flex cursor-pointer justify-start mb-4"
        >
          <div :class="`flex-shrink-0 rounded-md w-6 h-6 p-1 flex justify-center items-center ${getBackground(askTemperatureAccessPoints)}`">
            <input
              type="checkbox"
              class="hidden"
              :value="askTemperatureAccessPoints"
              @change="confirmAccessPointTemp('accessPoint', !askTemperatureAccessPoints)"
            >
            <svg
              class="w-6 h-6 text-white pointer-events-none"
              viewBox="0 0 172 172"
            ><g
              fill="none"
              stroke-width="none"
              stroke-miterlimit="10"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode:normal"
            ><path d="M0 172V0h172v172z" /><path
              d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z"
              fill="currentColor"
              stroke-width="1"
            /></g></svg>
          </div>
          <span class="self-center text-base select-none ml-2">
            Punto de acceso solo puede registrar cada usuario una vez al dia.
          </span>
        </label> -->
        <div class="bg-gray-100 rounded-sm border border-gray-300 p-4">
          <div class="text-lg mb-2">
            Preguntas vacunación
          </div>
          <div class="sm:flex sm:space-x-2">
            <div class="mb-8 sm:w-1/2">
              <tag-manager
                :success="success"
                :selectableTags="tags"
                :currentTags="currentFirstDosesTags"
                :rules="{ regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\-' ]*$/ }"
                @tag:add="addVaccinationTag($event, 'first')"
                @tag:remove="removeVaccinationTag($event, 'first')"
              >
                Por primera y segunda dosis:
              </tag-manager>
            </div>
            <div class="sm:w-1/2">
              <tag-manager
                :success="success"
                :selectableTags="tags"
                :currentTags="currentLastDoseTags"
                :rules="{ regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\-' ]*$/ }"
                @tag:add="addVaccinationTag($event, 'second')"
                @tag:remove="removeVaccinationTag($event, 'second')"
                @state:search="isSearching = $event"
              >
                Por todas las dosis:
              </tag-manager>
            </div>
          </div>
        </div>
        <label
          class="custom-label max-w-lg flex cursor-pointer justify-start mb-4 mt-5"
        >
          <div :class="`flex-shrink-0 rounded-md w-6 h-6 p-1 flex justify-center items-center ${getBackground(askTemperatureAccessPoints)}`">
            <input
              type="checkbox"
              class="hidden"
              :value="askTemperatureAccessPoints"
              @change="confirmAccessPointTemp('accessPoint', !askTemperatureAccessPoints)"
            >
            <svg
              class="w-6 h-6 text-white pointer-events-none"
              viewBox="0 0 172 172"
            ><g
              fill="none"
              stroke-width="none"
              stroke-miterlimit="10"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode:normal"
            ><path d="M0 172V0h172v172z" /><path
              d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z"
              fill="currentColor"
              stroke-width="1"
            /></g></svg>
          </div>
          <span class="self-center text-base select-none ml-2">
            Pedir temperatura en los puntos de acceso.
          </span>
        </label>
        <label
          class="custom-label max-w-lg flex cursor-pointer justify-start mb-4"
        >
          <div :class="`flex-shrink-0 rounded-md w-6 h-6 p-1 flex justify-center items-center ${getBackground(askForTemperature)}`">
            <input
              type="checkbox"
              class="hidden"
              :value="askForTemperature"
              @change="toggleAskForTemperature('poll', !askForTemperature)"
            >
            <svg
              class="w-6 h-6 text-white pointer-events-none"
              viewBox="0 0 172 172"
            ><g
              fill="none"
              stroke-width="none"
              stroke-miterlimit="10"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode:normal"
            ><path d="M0 172V0h172v172z" /><path
              d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z"
              fill="currentColor"
              stroke-width="1"
            /></g></svg>
          </div>
          <span class="self-center text-base select-none ml-2">
            Pedir temperatura en las encuestas.
          </span>
        </label>
        <div
          v-if="askForTemperature"
          class="flex justify-start mt-3"
        >
          <div>
            Temperatura límite para considerar fiebre
          </div>
          <div class="ml-5">
            <input
              id="temperature-input"
              type="number"
              step="0.1"
              class="border border-gray-400 focus:bg-gray-200 w-16 pl-1"
              :value="temperatureLimit"
              @blur="saveFormParameter('temperatureLimit', Number($event.target.value))"
            >
            <span>
              °C
            </span>
          </div>
        </div>
        <div class="flex justify-start mt-5">
          <div class="mr-5 mt-1">
            Categoría para invitados
          </div>
          <select
            :value="guestCategoryID"
            name="hours"
            class="p-2 bg-gray-200"
            @change="saveFormParameter('guestCategoryID', $event.target.value)"
          >
            <option
              v-for="categoryID of categoryIDs"
              :key="categoryID"
              :value="categoryID"
            >
              {{ categories[categoryID].name }}
            </option>
          </select>
        </div>
        <div class="flex justify-start mt-5">
          <div class="mr-5 mt-1">
            Ponderado mínimo para <span class="font-bold">prohibir</span> la entrada
          </div>
          <div class="ml-5">
            <input
              id="temperature-input"
              type="number"
              class="border border-gray-400 focus:bg-gray-200 w-16 pl-1"
              :value="maxRiskLevelSum"
              min="1"
              max="999"
              @blur="saveFormParameter('maxRiskLevelSum', Number($event.target.value))"
            >
          </div>
        </div>
        <div class="flex mt-2 font-bold text-green-500">
          <div>
            Mensaje de acceso aprobado
          </div>
          <div class="ml-5 w-full">
            <input
              type="text"
              class="border border-gray-400 focus:bg-gray-200 w-full pl-1"
              :value="entryApprovedMessage"
              @blur="saveFormParameter('entryApprovedMessage', $event.target.value)"
            >
          </div>
        </div>
        <div class="flex mt-2 font-bold text-yellow-500">
          <div>
            Mensaje de acceso condicionado
          </div>
          <div class="w-full">
            <input
              type="text"
              class="border border-gray-400 focus:bg-gray-200 w-full pl-1"
              :value="entryConditionedMessage"
              @blur="saveFormParameter('entryConditionedMessage', $event.target.value)"
            >
          </div>
        </div>
        <div class="flex mt-2 font-bold text-red-500">
          <div>
            Mensaje de acceso denegado
          </div>
          <div class="ml-5 w-full">
            <input
              type="text"
              class="border border-gray-400 focus:bg-gray-200 w-full pl-1"
              :value="entryDeniedMessage"
              @blur="saveFormParameter('entryDeniedMessage', $event.target.value)"
            >
          </div>
        </div>
      </div>
      <div
        class="p-4 shadow cursor-pointer"
        @click="accordion.notification = !accordion.notification"
      >
        <div class="flex justify-between">
          <div class="font-bold">
            Notificación a usuarios
          </div>
          <eva-icon
            :name="accordion.notification ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'"
            fill="#282A43"
          />
        </div>
      </div>
      <div
        v-if="accordion.notification"
        class="content shadow p-4 bg-white"
      >
        <p>Hora de envío</p>
        <div class="flex w-full items-center">
          <select
            v-model="hours"
            name="hours"
            class="p-2 bg-gray-200"
            @change="updateCronTime()"
          >
            <option
              v-for="hourIndex in 24"
              :key="hourIndex - 1"
              :value="hourIndex - 1"
            >
              {{ hourIndex - 1 }}
            </option>
          </select>
          <span class="text-xl font-bold mx-2">:</span>
          <select
            v-model="minutes"
            name="minutes"
            class="p-2 bg-gray-200"
            @change="updateCronTime()"
          >
            <option
              v-for="hourIndex in 60"
              :key="hourIndex - 1"
              :value="hourIndex - 1"
            >
              {{ hourIndex - 1 }}
            </option>
          </select>
        </div>
      </div>
      <a
        v-if="!isEditing"
        class="sm:w-64 cursor-pointer text-white bg-purple-500 flex px-4 py-2 rounded-md items-center text-md my-5 hover:bg-purple-400"
        @click="isEditing = true"
      >
        <eva-icon
          name="plus-outline"
          fill="#FFFFFF"
        />
        <div
          class="block-inline text-center w-full"
        >
          Nueva categoría
        </div>
      </a>
      <ValidationObserver
        v-else
        ref="form"
        v-slot="{ handleSubmit }"
      >
        <form
          id="myForm"
          class="min-w-64 my-5 p-4 rounded-md shadow-md text-lg"
          @submit.prevent="handleSubmit(onSubmit)"
        >
          ¿Cómo llamarás esta categoría?
          <ValidationProvider
            v-slot="{ errors, valid }"
            mode="aggressive"
            vid="category"
            name="Categoría"
            :rules="{ regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\- .' ]*$/, required: true }"
          >
            <input
              ref="categoryInput"
              v-model="editingValue"
              name="categoryLabel"
              type="text"
              class="rounded-lg w-full text-2xl px-2 border border-gray-400 focus:bg-gray-200"
            >
            <p class="text-red-500 text-center mx-1">
              {{ errors[0] }}
            </p>
            <div class="flex justify-end">
              <a
                class="sm:w-64 cursor-pointer text-gray flex px-4 py-2 rounded-md items-center text-md mt-4"
                @click="isEditing = false; editingValue = ''"
              >
                <div
                  class="block-inline text-center w-full"
                >
                  Cancelar
                </div>
              </a>
              <button
                type="submit"
                :disabled="!valid"
                class="disabled:opacity-25 disabled:pointer-events-none bg-green-400 sm:w-64 text-white flex px-4 py-2 rounded-md items-center text-md mt-4"
              >
                <eva-icon
                  name="save-outline"
                  fill="#FFFFFF"
                />
                <div
                  class="block-inline text-center w-full"
                >
                  Guardar
                </div>
              </button>
            </div>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <div
        v-for="categoryID in categoryIDs"
        :key="categoryID"
      >
        <category-card
          v-if="categoryID === selectedCategoryID"
          :categoryID="categoryID"
          :category="categories[categoryID]"
          @collapse="selectedCategoryID = null"
        />
        <div
          v-else
          class="cursor-pointer text-lg min-w-64 my-5 p-4 rounded-md shadow-md border-2 border-purple-500 border-opacity-0 hover:border-opacity-100"
          @click="selectedCategoryID = categoryID"
        >
          {{ categories[categoryID].name }}
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as axios from 'axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import categoryCard from '../components/categoryCard'
import tagManager from '../components/tagManager'

export default {
  components: {
    categoryCard,
    ValidationProvider,
    ValidationObserver,
    tagManager,
  },
  props: {
  },
  data () {
    return {
      hours: '',
      minutes: '',
      accordion: {
        parameters: false,
        notification: false,
      },
      isEditing: false,
      selectedCategoryID: null,
      selectedFieldID: null,
      newSectionLabel: '',
      editingValue: '',
      success: false,
    }
  },
  computed: {
    cronID () {
      return this.instancesInfo[this.instanceID].notificationSettings?.cronID
    },
    maxRiskLevelSum () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.maxRiskLevelSum || 4
    },
    entryDeniedMessage () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.entryDeniedMessage || 'No debes salir de casa ni puedes ingresar a las instalaciones de la institución.'
    },
    entryApprovedMessage () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.entryApprovedMessage || 'Presentando el código QR se te permitirá ingreso.'
    },
    entryConditionedMessage () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.entryConditionedMessage || 'Al ingresar debes dirigirte a la enfermería.'
    },
    guestCategoryID () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.guestCategoryID
    },
    categories () {
      return this.instancesInfo[this.instanceID].dictionary.form.categories
    },
    categoryIDs () {
      return this.instancesInfo[this.instanceID].dictionary.form.categoryIDs
    },
    askForTemperature () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.askForTemperature
    },
    askTemperatureAccessPoints () {
      const value = this.instancesInfo[this.instanceID].dictionary.parameters.askTemperatureAccessPoints
      return typeof value === 'undefined' ? true : value
    },
    askForFirstDosesTagIDs () {
      if (!this.instance) {
        return {}
      }
      return this.instance.dictionary.parameters.askForFirstDosesTagIDs || {}
    },
    askForLastDoseTagIDs () {
      if (!this.instance) {
        return {}
      }
      return this.instance.dictionary.parameters.askForLastDoseTagIDs || {}
    },
    currentFirstDosesTags () {
      const tags = {}
      if (!this.askForFirstDosesTagIDs) {
        return tags
      }
      for (const tagID of Object.keys(this.askForFirstDosesTagIDs)) {
        tags[tagID] = this.tags[tagID]
      }
      return tags
    },
    currentLastDoseTags () {
      const tags = {}
      if (!this.askForLastDoseTagIDs) {
        return tags
      }
      for (const tagID of Object.keys(this.askForLastDoseTagIDs)) {
        tags[tagID] = this.tags[tagID]
      }
      return tags
    },
    temperatureLimit () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.temperatureLimit || 38
    },
    isDoneReporting () {
      return Object.keys(this.alreadyReportedToday).length === Object.keys(this.persons).length
    },
    canSubmit () {
      const anySymptom = Object.keys(this.reportedSymptoms).length > 0
      return this.noSymptoms || anySymptom
    },
    instance () {
      return this.instancesInfo[this.instanceID]
    },
    ...mapState({
      account: state => state.auth.account,
      uid: state => state.auth.uid,
      instanceID: state => state.admin.instanceID,
      instancesInfo: state => state.auth.instancesInfo,
    }),
    ...mapGetters({
      tags: 'admin/tags',
    }),
  },
  watch: {
    isEditing: function (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.categoryInput.focus()
        })
      }
    },
  },
  mounted () {
    this.hours = this.instancesInfo[this.instanceID].notificationSettings?.sendTime?.hours
    this.minutes = this.instancesInfo[this.instanceID].notificationSettings?.sendTime?.minutes
  },
  methods: {
    async addVaccinationTag (tagID, doses) {
      console.info(tagID)
      try {
        this.$f7.preloader.show('Actualizando categoría...')
        this.success = false
        console.info({
          doses,
          tagID,
          instanceID: this.instanceID,
        })
        const response = await axios({
          url: '/instances/form/addVaccinationTag',
          method: 'POST',
          data: {
            doses,
            tagID,
            instanceID: this.instanceID,
          },
        })
        this.success = true
        this.$f7.preloader.hide()
        console.info(response)
      } catch (err) {
        this.$f7.preloader.hide()
        console.error(err)
      }
    },
    async removeVaccinationTag (tagID, doses) {
      try {
        this.$f7.preloader.show('Actualizando categoría...')
        this.success = false
        const response = await axios({
          url: '/instances/form/removeVaccinationTag',
          method: 'POST',
          data: {
            doses,
            tagID,
            instanceID: this.instanceID,
          },
        })
        this.success = true
        this.$f7.preloader.hide()
        console.info(response)
      } catch (err) {
        this.$f7.preloader.hide()
        console.error(err)
      }
    },
    async updateCronTime () {
      try {
        this.$f7.dialog.preloader('Guardando...')
        const response = await axios({
          url: 'cronJobs/updateReminderJob',
          method: 'POST',
          data: {
            instanceID: this.instanceID,
            cronID: this.cronID,
            minutes: this.minutes,
            hours: this.hours,
          },
        })
        console.info(response)
      } catch (err) {
        console.error(err)
      } finally {
        this.$f7.dialog.close()
      }
    },
    getWeightClass (weight) {
      let style = 'p-2 font-bold text-white'
      if (weight === 0) {
        style += ' bg-green-500'
      }
      if (weight === 1) {
        style += ' bg-yellow-500'
      }
      if (weight === 2) {
        style += ' bg-orange-500'
      }
      if (weight === 3) {
        style += ' bg-red-500'
      }
      return style
    },
    async confirmAccessPointTemp (type, val) {
      this.$f7.dialog.confirm('Estas cambiando una opcion del registro de ingreso, revisa previamente los <span style="color:#FF7570; font-weight:bold">decretos establecidos por las autoridades.</span>', '¡Cuidado!', async () => {
        try {
          this.toggleAskForTemperature(type, val)
        } catch (err) {
          console.error(err)
        }
      })
    },
    async toggleAskForTemperature (type, val) {
      try {
        this.$f7.dialog.preloader('Actualizando preguntas...')
        await axios({
          url: '/instances/form/askForTemperature/toggle',
          method: 'POST',
          data: {
            askForTemperature: val,
            type: type,
            instanceID: this.instanceID,
          },
        })
        this.$f7.preloader.hide()
      } catch (err) {
        console.error(err)
      } finally {
        this.$f7.dialog.close()
      }
    },
    async saveFormParameter (field, value) {
      try {
        this.$f7.dialog.preloader('Actualizando categoría...')
        const response = await axios({
          url: '/instances/form/parameter/update',
          method: 'POST',
          data: {
            field,
            instanceID: this.instanceID,
            value,
          },
        })
        console.info(response)
      } catch (err) {
        console.error(err)
      } finally {
        this.$f7.dialog.close()
      }
    },
    async onSubmit () {
      try {
        this.$f7.dialog.preloader('Creando categoría...')
        const response = await axios({
          url: '/instances/createCategory',
          method: 'POST',
          data: {
            instanceID: this.instanceID,
            categoryLabel: this.editingValue,
          },
        })
        console.info(response)
      } catch (err) {
        console.error(err)
      } finally {
        this.editingValue = ''
        this.isEditing = false
        this.$f7.dialog.close()
      }
    },
    getBackground (itemVal) {
      return !itemVal ? 'bg-purple-200' : 'bg-purple-500'
    },
  },
}
</script>
<style lang='scss'>
@import '../css/brand';
</style>
